export default class PersistentData{
    constructor(id){
       /* this.pathId = (id || 'global');
        this.savePath = "PersistentData:" + this.pathId;*/
        this.storageId = id;
        this.storage = window.localStorage;
    }

    set storageId(id){
        this.pathId = (id || 'global');
        this.savePath = "PersistentData:" + this.pathId;
    }

    get storageId(){
        return this.pathId;
    }

    get dataPath(){
        return this.pathId;
    }

    get rootPath(){
        return this.pathId;
    }

    /*
        lifeSpan - How long in miliseconds the data should exsist
    */
    setData(key, value, lifeSpan){
        if(key === undefined)return;
        let dataObject = {data:value, type:typeof(value)};
        if(!isNaN(lifeSpan)){
            let expire = (new Date()).getTime() + Number(lifeSpan);
            dataObject.expire = expire;
        }
        this.storage.setItem(this.savePath + "/" + key, JSON.stringify(dataObject));
    }

    hasData(key){
        return this.getData(key) != null;
    }

    getData(key){
        let dataString = this.storage.getItem(this.savePath + "/" + key);
        if(dataString){
            let data = JSON.parse(dataString);
            if(!isNaN(data.expire)){
                let expiry = new Date(data.expire);
                if((new Date()).getTime() >= expiry.getTime()){
                    this.removeData(key);
                    return null;
                }
            }
            return data.data;
        }
        return null;
    }

    removeData(key){
        console.log('Sotrage Deleting Key:', key);
        this.storage.removeItem(this.savePath + "/" + key);
    }

    getAll(path, includeSubs){

        let items = [];
        let p = (path)? '/' + path + '/' : '';
        let rootPath = this.savePath +  p;
        let rootPathDepth = rootPath.split('/').length;

        let maxPathDepth = (includeSubs)? null:1;

        for(let i=0; i < this.storage.length; i++){
            let key = this.storage.key(i);


                    

            if(key.indexOf(rootPath) === 0){
                if(maxPathDepth == null){
                    items.push(JSON.parse(this.storage.getItem(key)).data);
                }else {
                    //console.log("*********** key:", key, " rootPath:", rootPath, "  maxPathDepth:", maxPathDepth, "   Depth:", (key.split('/').length - rootPathDepth) );
                    if( (key.split('/').length - rootPathDepth) <= maxPathDepth ){
                        
                        items.push(JSON.parse(this.storage.getItem(key)).data);
                    }
                }                
            }            
        }

        return items;
    }

    clear(){

        let removeKeys = [];

        for(let i=0; i < this.storage.length; i++){
            let key = this.storage.key(i);
            if(key.indexOf(this.savePath + '/') === 0){
                removeKeys.push(key);
            }            
        }

        for(let i=0; i < removeKeys.length; i++){
            this.storage.removeItem(removeKeys[i]);
        }

        return removeKeys;

    }
}



// WEBPACK FOOTER //
// ./src/api/PersistentData.js